import { render } from "./EditaVeiculo.vue?vue&type=template&id=484bd1ab&scoped=true&ts=true"
import script from "./EditaVeiculo.vue?vue&type=script&lang=ts"
export * from "./EditaVeiculo.vue?vue&type=script&lang=ts"

import "./EditaVeiculo.vue?vue&type=style&index=0&id=484bd1ab&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484bd1ab"]])

export default __exports__